module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-page"
  }, [_c('div', {
    staticClass: "chat-conversation-header chat-hero"
  }, [_c('button', {
    staticClass: "chat-icon-button",
    attrs: {
      "title": _vm.locale.t('label_back')
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "ti-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-conversation-heading"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_faq')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t('label_chat')))])]), _vm._v(" "), (_vm.canManageFaq()) ? _c('div', {
    staticClass: "chat-actions"
  }, [_c('button', {
    staticClass: "chat-action-button",
    on: {
      "click": _vm.startAdd
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_faq_add_new')) + "\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.canManageFaq() && _vm.showForm) ? _c('div', {
    staticClass: "chat-faq-form"
  }, [_c('div', {
    staticClass: "chat-faq-form__grid"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_faq_question')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.question),
      expression: "form.question"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "question", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_faq_order_number')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orderNumber),
      expression: "form.orderNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "orderNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_faq_answer')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.answer),
      expression: "form.answer"
    }],
    staticClass: "form-control input",
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.form.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "answer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "chat-faq-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.active),
      expression: "form.active"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.active) ? _vm._i(_vm.form.active, null) > -1 : (_vm.form.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "active", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.t('label_faq_active')))])]), _vm._v(" "), _c('div', {
    staticClass: "chat-actions chat-faq-form__actions"
  }, [_c('button', {
    staticClass: "chat-action-button chat-action-button--secondary",
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_cancel')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "chat-action-button",
    attrs: {
      "disabled": _vm.isSaving || !_vm.isFormValid()
    },
    on: {
      "click": _vm.saveFaq
    }
  }, [_vm._v("\n        " + _vm._s(_vm.locale.t('label_save')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chat-panel chat-faq-panel"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_loading')))]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "form-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : (_vm.faqs.length === 0) ? _c('div', {
    staticClass: "chat-empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_faq_empty')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.faqs), function(faq) {
    return _c('div', {
      key: faq.id,
      staticClass: "chat-faq-item"
    }, [_c('div', {
      staticClass: "chat-faq-question"
    }, [_c('button', {
      staticClass: "chat-faq-question__toggle",
      on: {
        "click": function($event) {
          return _vm.toggleFaq(faq.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(faq.question))])]), _vm._v(" "), (_vm.canManageFaq()) ? _c('span', {
      staticClass: "chat-faq-status",
      class: {
        'is-inactive': !faq.active
      }
    }, [_vm._v("\n          " + _vm._s(faq.active ? _vm.locale.t('label_faq_active') : _vm.locale.t('label_faq_inactive')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canManageFaq()) ? _c('div', {
      staticClass: "chat-faq-admin-actions"
    }, [_c('button', {
      staticClass: "chat-close-button",
      attrs: {
        "title": _vm.locale.t('label_faq_edit')
      },
      on: {
        "click": function($event) {
          return _vm.editFaq(faq)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "chat-close-button",
      attrs: {
        "title": _vm.locale.t('label_faq_active')
      },
      on: {
        "click": function($event) {
          return _vm.toggleActive(faq)
        }
      }
    }, [_c('i', {
      staticClass: "ti-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "chat-close-button",
      attrs: {
        "title": _vm.locale.t('label_delete')
      },
      on: {
        "click": function($event) {
          return _vm.confirmDelete(faq)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "chat-faq-chevron",
      on: {
        "click": function($event) {
          return _vm.toggleFaq(faq.id)
        }
      }
    }, [_c('i', {
      class: _vm.isFaqOpen(faq.id) ? 'ti-angle-up' : 'ti-angle-down'
    })])]), _vm._v(" "), (_vm.isFaqOpen(faq.id)) ? _c('div', {
      staticClass: "chat-faq-answer"
    }, [_c('p', [_vm._v(_vm._s(faq.answer))]), _vm._v(" "), (_vm.canManageFaq()) ? _c('div', {
      staticClass: "chat-faq-admin-row"
    }, [_c('span', [_vm._v(_vm._s(_vm.locale.t('label_faq_order_number')) + ": " + _vm._s(faq.orderNumber))])]) : _vm._e()]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f808393c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat/ChatFaq.vue
// module id = 861
// module chunks = 0